import { render, staticRenderFns } from "./PreapprovedInvoiceDashboard.vue?vue&type=template&id=1430f6a3"
import script from "./PreapprovedInvoiceDashboard.vue?vue&type=script&lang=js"
export * from "./PreapprovedInvoiceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1430f6a3')) {
      api.createRecord('1430f6a3', component.options)
    } else {
      api.reload('1430f6a3', component.options)
    }
    module.hot.accept("./PreapprovedInvoiceDashboard.vue?vue&type=template&id=1430f6a3", function () {
      api.rerender('1430f6a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/PreapprovedInvoiceDashboard.vue"
export default component.exports